import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [{
        path: '/',
        name: 'home',
        component: () =>
            import ('./views/index.vue')
    }, {
        path: '/listChannel',
        name: 'listChannel',
        component: () =>
            import ('./views/listChannel.vue')
    }, {
        path: '/listLeaf',
        name: 'listLeaf',
        component: () =>
            import ('./views/listLeaf.vue')
    }, {
        path: '/search',
        name: 'search',
        component: () =>
            import ('./views/search.vue')
    },
    {
        path: '/dynamic',
        name: 'home1',
        component: () =>
            import ('./views/Dynamic/index'),
    },
    {
        path: '/listChannelDynamic',
        name: 'listChannel',
        component: () =>
            import ('./views/Dynamic/listChannelDynamic')
    }, {
        path: '/listLeafDynamic',
        name: 'listLeafDynamic',
        component: () =>
            import ('./views/Dynamic/listLeafDynamic')
    },
    {
        path: '/searchDynamic',
        name: 'searchDynamic',
        component: () =>
            import ('./views/Dynamic/searchDynamic')
    }
]
const router = new VueRouter({
    routes
})
export default router